export default __webpack_public_path__ + "static/media/autoselection.0ff4ea85.wav";